export const TabelaAcordoParcelas = () => {
  return (
    <div className="my-2">
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block w-full p-1.5 align-middle">
            <div className="max-h-[350px] overflow-hidden overflow-y-auto rounded-sm border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="sticky top-0 bg-gray-300">
                  <tr>
                    <th scope="col" className="th-cadastro">
                      Nº Contrato
                    </th>
                    <th scope="col" className="th-cadastro">
                      Parcela
                    </th>
                    <th scope="col" className="th-cadastro">
                      Vencimento
                    </th>
                    <th scope="col" className="th-cadastro">
                      Valor Atualizado
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">01</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">02</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">03</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">04</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">05</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">06</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">06</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">08</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">09</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">10</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">11</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">12</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">13</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">14</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">15</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">16</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">17</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">18</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">19</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">20</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">21</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">22</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">23</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                  <tr>
                    <td className="td-cadastro">32810</td>
                    <td className="td-cadastro">24</td>
                    <td className="td-cadastro">13/03/2023</td>
                    <td className="td-cadastro">265</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
